import { render, staticRenderFns } from "./PaiHangBangLunBoBiao.vue?vue&type=template&id=80b966e4&scoped=true&"
import script from "./PaiHangBangLunBoBiao.vue?vue&type=script&lang=js&"
export * from "./PaiHangBangLunBoBiao.vue?vue&type=script&lang=js&"
import style0 from "./PaiHangBangLunBoBiao.vue?vue&type=style&index=0&id=80b966e4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b966e4",
  null
  
)

export default component.exports